import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CNPJInput from "../component/CNPJInput";
import useApp from "../context/AppContext";
import { api } from "../utils/api";

const CasdastrarSenha = () => {
  const { showModalMessage, setUserEmailAtivacao,setLoading, showModalError } = useApp();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const classPassword = password === "" ? "input100" : "input100 has-val";
  const classPasswordConfirm = password === "" ? "input100" : "input100 has-val";

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    if (passwordConfirm !== password) {
      setPassword("");
      setPasswordConfirm("");
      showModalMessage("Erro", <p>Senha divergente da confirmação de senha, tente novamente</p>);
    } else {      
      setLoading(true);
      api().post("/auth/cadastrarSenha", { cnpj: username, newpassword: password })
        .then((resp) => {
          if (resp.status === 200) {
            setUserEmailAtivacao(username,resp.data);
            navigate("/codigoAtivacao")
            setLoading(false);;
          } 
          else {
            showModalMessage("Erro", <p>{resp.data}</p>);
            setLoading(false);;
          }          
        })
        .catch(function (error) {
          setLoading(false);
          if (error.response && error.response.status === 406) {
            showModalMessage(
              "NFS-Recebimento",
              <>
                <h2>O CNPJ informado não possui e-mail cadastrado!</h2>
                <p>Para gerar uma senha de acesso é necessário ter um e-mail cadastrado em nosso sistema.</p>
                <p>
                  Por favor, entre em contato com o <b>Departamento de Compras</b> pelo telefone: + 55 (12) 3908-XXXX
                </p>
              </>
            );
          } else {
            showModalError("Erro ao acessar servidor.");
          }
        });
    }
    event.preventDefault();
  };
  return (
    <div className="limiter bghome">
      <div className="container-login100">
        <div className="wrap-login100">
          <form className="login100-form validate-form" onSubmit={handleSubmit}>
            <span className="login100-form-other">GERAÇÃO DE SENHA</span>
            <span className="login100-form-subtitle">Portal de Fornecedores</span>

            <div className="wrap-input100 validate-input m-t-55 m-b-35" data-validate="Enter username">
              <CNPJInput value={username} setValue={setUsername} />
              <span className="focus-input100" data-placeholder="CNPJ"></span>
            </div>

            <div className="wrap-input100 validate-input m-b-50" data-validate="Enter password">
              <input
                className={classPassword}
                type="password"
                name="pass"
                required
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
              />
              <span className="focus-input100" data-placeholder="Informe uma senha"></span>
            </div>

            <div className="wrap-input100 validate-input m-b-50" data-validate="Enter password">
              <input
                className={classPasswordConfirm}
                type="password"
                name="pass"
                required
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.currentTarget.value)}
              />
              <span className="focus-input100" data-placeholder="Informe a senha novamente"></span>
            </div>

            <div className="container-login100-form-btn">
              <button className="login100-form-btn" type="submit">
                GERAR SENHA
              </button>
            </div>

            <ul className="login-more p-t-60 pl-0">
              <li>
                <span className="txt1">Já tem senha? </span>
                <Link to="/login" className="txt2">Faça o login!</Link>
              </li>
            </ul>
          </form>
          <span className="urbam_footer">URBAM - URBANIZADORA MUNICIPAL S.A</span>
        </div>
      </div>
    </div>
  );
};

export default CasdastrarSenha;
